export const ITERABLE_LOCAL_STORAGE_ID = 'iterableLocalStorage';

/*------------------------------------------------------------------------------------------------*/
/* PRIVATE FUNCTIONS                                                                              */
/*------------------------------------------------------------------------------------------------*/
const privateGetStorage = (defaultValue = {}) => {
  if (window.localStorage) {
    return JSON.parse(window.localStorage.getItem(ITERABLE_LOCAL_STORAGE_ID)) || defaultValue;
  }
  return {};
};

const privateSetStorage = (storage = {}) => {
  if (window.localStorage) {
    window.localStorage.setItem(ITERABLE_LOCAL_STORAGE_ID, JSON.stringify(storage));
  }
  return true;
};

/*------------------------------------------------------------------------------------------------*/
/* Public Local Storage Functions                                                                 */
/*------------------------------------------------------------------------------------------------*/
/**
 * **getItem**_(key)_<br>
 * Get an item from the iterable local storage.
 * @param { String } key: The key of the item to get.
 * @param { Any } defaultValue: If value does not exist, return default value.
 * @returns { Object } The item from local storage.
 */
export const getItem = (key, defaultValue) => {
  const storage = privateGetStorage(defaultValue);
  return storage[key];
};

/**
 * **setItem**_(key)_<br>
 * Set an item in the iterable local storage.
 * @param { String } key: The key of the item to set.
 * @param { Any } value: The value of the item to set.
 * @returns { Boolean } The item was set.
 */
export const setItem = (key, value) => {
  const storage = { ...privateGetStorage(), [key]: value };
  return privateSetStorage(storage);
};

/**
 * **removeItem**_(key)_<br>
 * Removes an item in the iterable local storage.
 * @param { String } key: The key of the item to remove.
 * @returns { Boolean } The item was set.
 */
export const removeItem = (key) => {
  const storage = { ...privateGetStorage(), [key]: undefined };
  return privateSetStorage(storage);
};
